<cs-item-list>
  <cs-item-list-header data-test="measure-test-header">Input Measure test</cs-item-list-header>

  <cs-item vertical>
    <cs-label>Body Weight (kg/lb/st_lb):</cs-label>
    <cs-input-measure input-sequence [(canonValue)]="bodyWeight" [(userUnit)]="bodyWeightUnit" type="bodyweight_kg"
      data-test="input-measure-bodyweight" />
  </cs-item>

  <cs-item vertical>
    <cs-label>Skinfolds (mm):</cs-label>
    <cs-input-measure input-sequence [(canonValue)]="skinfold" type="skinfold_mm"
      data-test="input-measure-skinfold" />
  </cs-item>

  <cs-item vertical>
    <cs-label>Waist (cm/in):</cs-label>
    <cs-input-measure input-sequence [(canonValue)]="waist" [(userUnit)]="waistUnit" type="bodydimensions_cm"
      data-test="input-measure-waist" />
  </cs-item>

  <cs-item vertical>
    <cs-label>Body Height (cm/ft_in):</cs-label>
    <cs-input-measure input-sequence [(canonValue)]="bodyHeight" [(userUnit)]="bodyHeightUnit" type="bodyheight_cm"
      data-test="input-measure-height" />
  </cs-item>


  <cs-item>
    <cs-button item-right input-sequence (click)="onDoneClick()" [label]="'Done' | untranslated"
      data-test="reset-measure-values" fit-width>
    </cs-button>
  </cs-item>

  <cs-item>
    <cs-note item-right>Separated into two sections to test the input>button transition of input-sequence with "Done"
    button above.</cs-note>
  </cs-item>

  <cs-item vertical>
    <cs-label>Added Weight (kg/lb):</cs-label>
    <cs-input-measure input-sequence [(canonValue)]="addedWeight" [(userUnit)]="addedWeightUnit"
      type="addedweight_kg" [preselectValues]="addedWeightPreselectValues" data-test="input-measure-weight" />
  </cs-item>

  <cs-item>
    <cs-input-measure #addedWeightInput input-sequence [(canonValue)]="addedWeight" [(userUnit)]="addedWeightUnit"
      type="addedweight_kg" [preselectValues]="addedWeightPreselectValues" data-test="input-measure-weight"
      [pairedWith]="repsInput" pairRole="primary" />
    <cs-input-measure #repsInput input-sequence [(canonValue)]="reps" type="reps"
      [preselectValues]="repsPreselectValues" data-test="input-measure-reps" [pairedWith]="addedWeightInput"
      pairRole="secondary" />
  </cs-item>

  <cs-item vertical>
    <cs-label>Egg Weight (readonly - custom serving):</cs-label>
    <cs-input-measure input-sequence [(canonValue)]="eggWeight" [(userUnit)]="eggCustomUnit" type="foodweight_g"
      [customUnitConfigs]="eggCustomUnitConfigs" [readonly]="true" data-test="input-measure-egg-readonly" />
  </cs-item>

  <cs-item vertical>
    <cs-label>Egg Weight (standard units - g/oz/lb):</cs-label>
    <cs-input-measure input-sequence [(canonValue)]="eggWeight" [(userUnit)]="eggWeightUnit" type="foodweight_g"
      data-test="input-measure-egg-standard" />
  </cs-item>

  <cs-item>
    <cs-button item-right input-sequence (click)="showEggCustomUnit = !showEggCustomUnit" [label]="'Show Servings' | untranslated"
      data-test="show-servings-button" fit-width>
    </cs-button>
    <cs-note item-right>Clicking this from inside the keyboard, should show the next input and immediately focus
    it.</cs-note>
  </cs-item>

  @if (showEggCustomUnit) {
    <cs-item vertical>
      <cs-label>Egg Weight (custom serving units):</cs-label>
      <cs-input-measure input-sequence [(canonValue)]="eggWeight" [(userUnit)]="eggCustomUnit" type="foodweight_g"
        [customUnitConfigs]="eggCustomUnitConfigs" data-test="input-measure-egg-custom" />
    </cs-item>
  }

  <cs-item>
    <cs-note item-right>Note: The two egg weight fields above share the same canonValue ({{ eggWeight }}g). The custom
    units field shows a "Serving" button in the virtual keyboard that opens the unit selector.</cs-note>
  </cs-item>

  <cs-item>
    <cs-note item-right>Note: On mobile/touch devices, tapping the input-measure fields will show the virtual keyboard
    styled with the new dark theme.</cs-note>
  </cs-item>
</cs-item-list>
